// Local-timezone date helpers.
// IMPORTANT: never use .toISOString().slice(0,10) — that gives UTC and breaks
// users east of UTC around midnight local time.

export function todayIso() {
  const d = new Date();
  return localIso(d);
}

export function localIso(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
}

export function shiftIso(dateStr, days) {
  const d = new Date(dateStr);
  d.setDate(d.getDate() + days);
  return localIso(d);
}
